export default "__VITE_ASSET__BnrFSS_c__"